export default "__VITE_ASSET__19ba555b__"